import { useQuery } from '@tanstack/react-query';
import { getEcommTopSelling, type EcommTopSellingParams, type EcommTopSelling } from '../services/ecommTopSellingService';

export const useEcommTopSelling = (params: EcommTopSellingParams) => {
  return useQuery<EcommTopSelling[]>({
    queryKey: ['ecomm-topSellingProducts', params],
    queryFn: () => getEcommTopSelling(params),
    enabled: !!params.month, // only run if month is provided
    staleTime: 1000 * 60 * 5, // cache for 5 minutes
  });
};
